import { Textarea } from '@mantine/core';
import { CommonInputProps } from './DataInputField';

export function DataInputTextarea({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  ariaLabelledBy,
}: CommonInputProps) {
  return (
    <Textarea
      value={String(inputValue || '')}
      onChange={e => setInputValue(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      minRows={2}
      maxRows={4}
      autosize
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { width: '280px' } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
